import type {
  DateConvention,
  DateDetail,
  TimelineFraming,
  SectionNamingStyle,
  ResumeReturnFormat,
  VisuallyEmphatize,
} from "@/generated/fastapi";

export const DATE_CONVENTION_EUROPEAN = "european" as const;
export const DATE_CONVENTION_US = "us" as const;

export const dateConventionOptions: Record<DateConvention, string> =
  Object.freeze({
    [DATE_CONVENTION_EUROPEAN]: "European (DD/MM/YYYY)",
    [DATE_CONVENTION_US]: "US (MM/DD/YYYY)",
  });

export const DATE_DETAIL_DAY_MONTH_YEAR = "day_month_year" as const;
export const DATE_DETAIL_MONTH_YEAR = "month_year" as const;
export const DATE_DETAIL_YEAR_ONLY = "year_only" as const;

export const dateDetailOptions: Record<DateDetail, string> = Object.freeze({
  [DATE_DETAIL_DAY_MONTH_YEAR]: "Day, Month, Year (DD/MM/YYYY)",
  [DATE_DETAIL_MONTH_YEAR]: "Month, Year (MM/YYYY)",
  [DATE_DETAIL_YEAR_ONLY]: "Year Only (YYYY)",
});

export const TIMELINE_HIDDEN = "hidden" as const;
export const TIMELINE_NUMERICAL = "numerical" as const;
export const TIMELINE_WORDED = "worded" as const;
export const TIMELINE_PROPORTIONAL = "proportional" as const;

export const timelineFramingOptions: Record<
  TimelineFraming,
  { label: string; description?: string }
> = Object.freeze({
  [TIMELINE_HIDDEN]: {
    label: "Hidden",
    description: "No timeline information printed at all.",
  },
  [TIMELINE_NUMERICAL]: {
    label: "Numerical",
    description: "Exact dates shown (e.g., Jan 2020 - Dec 2021).",
  },
  [TIMELINE_WORDED]: {
    label: "Worded",
    description: 'Dates expressed in words (e.g., "Past").',
  },
  [TIMELINE_PROPORTIONAL]: {
    label: "Proportional",
    description: "Timeline represented proportionally without exact dates.",
  },
});

export const SECTION_NAMING_RESUME = "resume" as const;
export const SECTION_NAMING_MOVEON = "moveon" as const;
export const SECTION_NAMING_CUSTOM = "custom" as const;

export const sectionNamingStyleOptions: Record<
  SectionNamingStyle,
  { label: string; description?: string }
> = Object.freeze({
  [SECTION_NAMING_RESUME]: {
    label: "Resume Style",
    description: "Standard resume section names (e.g., Experience, Education).",
  },
  [SECTION_NAMING_MOVEON]: {
    label: "MoveOn Style",
    description:
      "Section names by MoveOn assessment conventions (e.g., Practical Skills, Domain Knowledge).",
  },
  [SECTION_NAMING_CUSTOM]: {
    label: "Custom Style",
    description: "User-defined section names for personalized resumes.",
  },
});

export const RESUME_RETURN_DOCX = "docx" as const;
export const RESUME_RETURN_PDF = "pdf" as const;

export const resumeReturnFormatOptions: Record<ResumeReturnFormat, string> =
  Object.freeze({
    [RESUME_RETURN_DOCX]: "DOCX",
    [RESUME_RETURN_PDF]: "PDF",
  });

export const VISUAL_EMPHASIZE_POSITION_OVER_CONTEXT =
  "position_over_context" as const;
export const VISUAL_EMPHASIZE_CONTEXT_OVER_POSITION =
  "context_over_position" as const;

export const visuallyEmphatizeOptions: Record<
  VisuallyEmphatize,
  { label: string; description?: string }
> = Object.freeze({
  [VISUAL_EMPHASIZE_POSITION_OVER_CONTEXT]: {
    label: "Position over Context",
    description: "Print position stronger that context",
  },
  [VISUAL_EMPHASIZE_CONTEXT_OVER_POSITION]: {
    label: "Context over Position",
    description: "Print context stronger that position",
  },
});
